<template>
  <!-- Modal -->
  <div class="modal fade" id="msgTray" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalID">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h2>Notification</h2>
          <h4>Subject</h4>
          <p>{{subject}}</p>
          <h4>Message</h4>
          <span v-html="message"></span>
          <h2>Reason</h2>
          <p>{{reason ? reason : 'No reason given.'}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { EventBus } from '../app.js';
    export default {
        props: ['status'],
        data() {
            return {
              reason:"",
              title:"",
              message:"",
              subject:"",
            };
        },
        mounted() {
          EventBus.$on('show_status', (payLoad) => {
            this.loadModel(payLoad);

          });
        },
        methods: {
          loadModel: function(status){
            var self = this;
            self.title = status.status_type + ' | '+ status.start_date +" - "+status.end_date;
            if(status.notification == null) {
              self.message = 'No message given.';
              self.subject = 'No subject given.';
            }else {
              self.message = status.notification.body;
              self.subject = status.notification.subject;
            }
            self.reason = status.reason;
            $('#msgTray').modal('show');
          }
        }
    }
</script>
